import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';
import { CompletionType } from '../models/completion-type.enum';

@Component({
  selector: 'edu-completion-animation',
  templateUrl: './completion-animation.component.html',
  styleUrls: ['./completion-animation.component.scss'],
  animations: [
    trigger('modalAnimation', [
      state(
        'void',
        style({
          opacity: 0,
          transform: 'scale(0.7)',
        }),
      ),
      state(
        'visible',
        style({
          opacity: 1,
          transform: 'scale(1)',
        }),
      ),
      transition('void => visible', [
        animate('0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'),
      ]),
      transition('visible => void', [animate('0.2s ease-out')]),
    ]),
    trigger('confettiAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(10px)' }),
        animate(
          '0.5s 0.1s cubic-bezier(0.34, 1.56, 0.64, 1)',
          style({ opacity: 1, transform: 'translateY(0)' }),
        ),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CompletionAnimationComponent implements OnInit, OnDestroy {
  @Input() message: string = 'Completed!';
  @Input() taskTitle: string = '';
  @Input() showPoints: boolean = false;
  @Input() pointsValue: number | null = null;
  @Input() completionType: CompletionType = CompletionType.TASK;

  animationState: 'visible' | 'void' = 'void';
  timeout: any;

  CompletionType = CompletionType; // Expose enum to template

  constructor() {}

  ngOnInit(): void {
    this.animationState = 'visible';

    // Auto-hide modal after 2.5 seconds
    this.timeout = setTimeout(() => {
      this.animationState = 'void';
    }, 2500);
  }

  ngOnDestroy(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
